import { Action } from "react-sweet-state";
import dcopy from "deep-copy";
import { GlobalState } from "../types";
import httpClient from "../../../utils/http-client";
import * as Sentry from "@sentry/react";

const clearAuthenticatedUser =
  (): Action<GlobalState> =>
  ({ getState, setState }) => {
    const prevState = getState();

    Sentry.configureScope((scope) => scope.setUser(null));
    sessionStorage.clear();
    httpClient.setAccessToken("");

    setState(dcopy({ ...prevState, user: undefined }));
  };

export default clearAuthenticatedUser;
